import { atom } from "recoil";
export const PacksUmrahAtom = atom({
  key: "PacksUmrahAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
